@import (reference) '../../../../../constants/spacing.module.less';

.additional-items-row-group-header-content {
  gap: @space-8;
  padding: @space-24 @space-16 @space-8 @space-16;
  border-top: 1px solid var(--default--border-color--10);
  border-bottom: 1px solid var(--default--border-color--10);
}
